/* eslint-disable max-classes-per-file */
import { observable, action, decorate } from 'mobx';
import { INVALID_ORDER } from '../logic/GetOrderError';

class Error {
  constructor(
    public id: string | null = null,
    public message: string | null = null,
    public level: string | null = null,
    public code: string | null = null
  ) {
    this.id = id;
    this.message = message;
    this.level = level;
    this.code = code;
  }

  getMessage() {
    return this.message;
  }

  getCode() {
    return this.code;
  }

  exists() {
    return this.message !== null;
  }

  isFatal() {
    return this.level === 'fatal';
  }

  isWarning() {
    return this.level === 'warning';
  }

  isOrderNotFound() {
    return this.code === '08010';
  }

  isOrderInvalid() {
    return this.message === INVALID_ORDER;
  }
}

class ErrorStore {
  FATAL = 'fatal';

  WARN = 'warning';

  GENERIC = 'Sorry, we did not succeed with that action, please try again.';

  screen: Record<string, Error> = {};

  set(
    id: string,
    error: undefined | { message: string | null; code?: string } = undefined,
    level = 'fatal'
  ) {
    if (!error || error?.message === 'false') {
      this.screen[id] = new Error(id, this.GENERIC, 'fatal');
    } else {
      this.screen[id] = new Error(id, error.message, level, error.code);
    }
  }

  get(id: string) {
    if (!this.screen[id]) {
      this.screen[id] = new Error();
    }
    return this.screen[id];
  }

  remove(id: string) {
    this.screen[id] = new Error();
  }
}

decorate(ErrorStore, {
  screen: observable,
  set: action,
});

export default ErrorStore;
